import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";

export const Optional = () => (
  <IgTypography color="text.secondary"> (optional)</IgTypography>
);
